/**
 * Ajax系セレクトのオプション設定を行う
 */
 $(function () {
     function clearSelect(elm, find = '') {
         // 指定選択肢をクリア
         let select = $(elm).parents('form').find(find);
         if (select.length > 0) {
             $(select).empty();
             $(select).select2({
                 width: "100%",
                 data: [{'id': '', 'text': '-----'}],
                 val: ''
             });
         }
         // 営業所に紐づく選択肢は全てクリアする
         if (find !== 'select.section-select' && find !== '') {
             return;
         }
         selects = [
             'select.account-user-select',
             'select.user-select',
             'select.driver-select',
             'select.employment-select',
             'select.occupation-select',
             'select.post-select',
             'select.vehicle-select',
         ]
         selects.forEach(function(value){
             let select = $(elm).parents('form').find(value);
             if (select.length > 0) {
                 $(select).empty();
                 $(select).select2({
                     width: "100%",
                     data: [{'id': '', 'text': '-----'}],
                     val: ''
                 });
             }
         })
     }

    // セレクトの値をセットする
    function setSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            let value = $(select).val();
            if (find === 'select.account-user-select') {
                datas.selected = value;
            }
            if (find === 'select.driver-select') {
                const checkbox = $(elm).parents('form').find('input[name=include_inactive_driver_flg]');
                // 「退職・休職を含む」のチェックボックスが存在していて、チェックがついていない場合
                if (checkbox.length > 0 && !checkbox.is(':checked')) {
                    datas.exclude_statuses = [checkbox.data('retire_status'), checkbox.data('suspension_status')]
                }
            }
            _ajax.post(action, datas, function (results) {
                $(select).empty();
                $(select).select2({
                    width: "100%",
                    data: results.options,
                    val: value
                });
                $(select).val(value).trigger('change');
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    // 選択初期値をセットする
    function setSelected(elm, find, datas = {}) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('selected-action');
            if (action != null) {
                _ajax.post(action, datas, function (results) {
                    $(select).val(results.value);
                }, function(xhr, status, errorThrown){
                    _error.omitted(xhr, status, errorThrown);
                });
            } else {
                $(select).val('');
            }
        }
    }

    // セレクトの値をセットする
    function setMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            _ajax.post(action, datas, function (results) {
                $(select).empty();
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id
                    }).text(option.text));
                })
                $(select).multipleSelect('refreshOptions', {
                    filter: false
                });
                $(select).multipleSelect('setSelects', []);
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    // セレクトの選択値をセットする
    function setMultiSelected(elm, find, datas = {}) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('selected-action');
            _ajax.post(action, datas, function (results) {
                if (results.value != null) {
                    $(select).multipleSelect('setSelects', results.value);
                } else {
                    $(select).multipleSelect('setSelects', []);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    // チェックボックスの値をセットする
    function setOccupationCheckbox(elm, datas = {}) {
        let checkbox = $(elm).parents('form').find('.occupation-check');
        if (checkbox.length > 0) {
            let action = $(checkbox).data('action');
            _ajax.post(action, datas, function (results) {
                let index = results.options.findIndex((v) => v.id == '');
                if (index == 0) {
                    results.options.splice(index, 1);
                }
                $(checkbox).children('div:not(.copy,.occupation-check-not-found)').remove();
                if (results.options.length > 0) {
                    $.each(results.options, function(index, option) {
                        let clone = $(checkbox).find('.copy').clone();
                        let input = $(clone).find('input');
                        let label = $(clone).find('label');
                        let id = $(input).attr('id') + option.id;
                        $(input).attr('id', id);
                        $(input).val(option.id);
                        $(input).data('occupation-type', option.type);
                        $(label).attr('for', id);
                        $(label).text(option.text);
                        $(clone).removeClass('copy').removeClass('display-none');
                        $(checkbox).append($(clone));
                    });
                    $(checkbox).find('.occupation-check-not-found').addClass('display-none');
                } else {
                    $(checkbox).find('.occupation-check-not-found').removeClass('display-none');
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

    // // ユーザーとドライバーのセレクト設定時の共通処置
    // function commonUserSelectedEvent(elm) {
    //     setSelect(elm, 'select.rollcall-authorizer-select', {'user_id': $(elm).val(), 'type': 'authorizer'});
    //     setSelect(elm, 'select.vehicle-select', {'user_id': $(elm).val()});
    // }

    /*---- グループ会社のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.holding-select', function () {
        setOccupationCheckbox(this);
        if ($(this).find('option:selected').length > 0 && $(this).find('option:selected').val() !== '') {
            setSelect(this, 'select.company-select', {'holding_id': $(this).val()});
            setMultiSelect(this, 'select.group-select', {'holding_id': $(this).val()});
        } else {
            clearSelect(this, 'select.company-select');
            clearSelect(this, 'select.section-select');
        }
    });

    /*---- 会社のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.company-select', function () {
        setOccupationCheckbox(this);
        if ($(this).find('option:selected').length > 0 && $(this).find('option:selected').val() !== '') {
            setSelect(this, 'select.section-select', {'company_id': $(this).val()});
            setMultiSelect(this, 'select.sections-select', {'company_id': $(this).val()});
            setSelect(this, 'select.notificationsection-select', {'company_id': $(this).val()});
            setSelect(this, 'select.company-vehicle-select', {'holding_id': $('.holding-select').val(),'company_id': $(this).val()});
        } else {
            clearSelect(this, 'select.section-select');
            clearSelect(this, 'select.notificationsection-select');
            clearSelect(this, 'select.company-vehicle-select');
        }
    });

    /*---- 営業所のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.section-select', function () {
        setOccupationCheckbox(this, {'section_id': $(this).val()});
        if ($(this).find('option:selected').length > 0 && $(this).find('option:selected').val() !== '') {
            setSelect(this, 'select.employment-select', {'section_id': $(this).val()});
            setSelect(this, 'select.occupation-select', {'section_id': $(this).val()});
            setSelect(this, 'select.post-select', {'section_id': $(this).val()});
            setSelect(this, 'select.account-user-select', {'section_id': $(this).val(), 'type': 'account'});
            setSelect(this, 'select.user-select', {'section_id': $(this).val()});
            setSelect(this, 'select.driver-select', {'section_id': $(this).val(), 'type': 'driver', 'route': $('select.driver-select').data('route')});
        } else {
            clearSelect(this);
        }
    });

    /*---- 車両が所属する営業所のセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.vehicle-section-select', function () {
        setSelect(this, 'select.vehicle-select', {'section_id': $(this).val()});
    });

    /*---- ユーザーのセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.user-select', function () {
        // commonUserSelectedEvent(this);
        setMultiSelected(this, 'select.group-select', {'user_id': $(this).val()})
    });

    // /*---- ドライバーのセレクト設定時 ----*/

    // // セレクト設定時
    // $(document).on('change', 'select.driver-select', function () {
    //     commonUserSelectedEvent(this);
    // });

    /*---- アカウント未設定ユーザーのセレクト設定時 ----*/

    // セレクト設定時
    $(document).on('change', 'select.account-user-select', function () {
        setMultiSelected(this, 'select.group-select', {'user_id': $(this).val()})
    });


    // セレクト２設定時
    $(document).on('select2:selecting', '.select2', function (e) {
        $(this).val(e.params.args.data.id);
        $(this).trigger('change');
    });

     /*---- 乗務員の「退職・休職を含む」押下時 ----*/

     // 乗務員の「退職・休職を含む」チェックボックス押下
     $(document).on('click', 'input[name=include_inactive_driver_flg]', function () {
        // 選択肢変更対象の要素
        const driverSelect = $(this).parents('form').find('select.driver-select');
        if (driverSelect.length > 0) {
            // 営業所セレクト要素
            let sectionSelect = $(this).parents('form').find('select.section-select');
            if (sectionSelect.length <= 0) {
                sectionSelect = $(this).parents('form').find('select.search-form-section-select');
            }
            // 営業所が選択されている場合のみ実行
            if (sectionSelect.find('option:selected').length > 0 && sectionSelect.find('option:selected').val() !== '') {
                setSelect(driverSelect, 'select.driver-select', {'section_id': sectionSelect.val(), 'type': 'driver'});
            }
        }
    });

});
